import React, { useContext } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useState, useEffect } from "react";
import Rating from "@mui/material/Rating";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Switch from "react-switch";
import Global, { isBusinessAccountType, saveReadedProduct, saveUnreadedProducts } from "../../util/Global";
import { useTranslation } from "react-i18next";
import { LoaderComponent } from "../../util/Loader";
import { AlertContext } from "../../util/Alerter";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import NotFound from "../../components/NotFound";
import { Typography } from "@mui/material";
import { CurrencyContext, getUserFullName } from "../../components/Utils";
import { GlobalData } from "../../util/GlobalData";

const PRODUCT_DETAILS_URL = Global.backend + "/index.php/produit/show";
const PRODUCT_DELETE_URL = Global.backend + "/index.php/produit/delete";
const AVIS_URL = Global.backend + "/index.php/avis/avisofproduct";
const PRODUCT_updateVisibilite_URL = Global.backend + "/index.php/api/produit/updateVisibilite";

const MyProductDetails = ({ isAdmin }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState(true);
  const [productDetails, setProductDetails] = useState([]);

  const [isVisible, setisVisible] = useState(false);
  const [selectedImg, setselectedImg] = useState(0);
  const [commentList, setCommentList] = React.useState([]);
  const [moyenRating, setMoyenRating] = React.useState(0);
  const [moyenCusmers, setMoyenCusmers] = React.useState(0);
  const { showAlert } = useContext(AlertContext)
  const { currency, getCurrencyPrice } = useContext(CurrencyContext)

  const { countUnreadedProducts, setcountUnreadedProducts, setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)



  useEffect(() => {
    if (isAdmin) {
      setpageNavLink({ path: "/dashboard/admin", label: "adminDashboard" })
      setnavLinks([{ path: "/dashboard/admin/products", label: "productList" }])
    } else {
      setnavLinks([{ path: "/dashboard/user/myproducts", label: "productList" }])
      setpageNavLink({ path: "/dashboard/user/addproduct", label: "addProduct" })
    }
    setpageTitle("product.details")
    setalertTitle("")
  }, [])


  useEffect(() => {
    setisLoading(true)

    axios.all([
      axios.post(PRODUCT_DETAILS_URL, { produitId: id }),
      axios.post(AVIS_URL, { produitId: id })
    ]).then((axios.spread((productResponse, avisResponse) => {
      // mark as read
      if (productResponse.data && saveReadedProduct(id)) {
        setcountUnreadedProducts(countUnreadedProducts - 1)
        saveUnreadedProducts(countUnreadedProducts - 1)
      }


      fetchProductDetails(productResponse);
      fetchAvisList(avisResponse);
    }))).catch((err) => {
      showAlert("error", t("request.errorFetchProductDetails"))
    }).finally(() => {
      setisLoading(false)
    })

  }, []);

  function fetchProductDetails(response) {
    setProductDetails(response.data);

    if (response.data) {
      setisVisible(response.data.visibilite);
    }
  }
  function fetchAvisList(response) {
    let moy = 0;

    response.data.map(avis => moy += avis.etoile_nb)

    setCommentList(response.data);
    setMoyenRating(moy / response.data.length);
    setMoyenCusmers(response.data.length);
  }










  // this.state = { checked: false };
  // this.handleChange = this.handleChange.bind(this);

  // handleChange(checked) {
  //   this.setState({ checked });
  // }








  const nobold = {
    fontWeight: "500",
    fontSize: 20,
    height: "auto",
  };



  const deleteProduct = () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success ml-3",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: t("alertTitle.confirm"),
        text: t("deleteProduct"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: t("alertButton.delete"),
        cancelButtonText: t("alertButton.cancel"),
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          setisLoading(true)
          axios.post(PRODUCT_DELETE_URL, { produitId: id }).then(() => {
            showAlert("success", t("request.successDeleteProduct"))
            if (isAdmin) {
              navigate("/dashboard/admin/products")
            } else {
              navigate("/dashboard/user/myproducts")
            }
          }).catch((err) => {
            showAlert("error", t("request.errorDeleteProduct"))
          }).finally(() => {
            setisLoading(false)

          })
        }
      });
  };




  return (
    <LoaderComponent isLoading={isLoading}>
      {!isLoading &&
        (!productDetails ? <NotFound /> :
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-5">
                        <div className="product-detail">
                          <div className="row">
                            <div className="col-3">
                              <div
                                className="nav flex-column nav-pills"
                                id="v-pills-tab"
                                role="tablist"
                                aria-orientation="vertical"
                              >
                                {productDetails.image?.map(
                                  (img, index) => (
                                    <a
                                      key={index}
                                      onClick={() =>
                                        setselectedImg(index)
                                      }
                                      style={{ marginBottom: 5 }}
                                      className={selectedImg == index ? "active" : ""}
                                    >
                                      <img
                                        src={`${Global.backend}/uploads/${img?.imageURL}`}
                                        alt=""
                                        className="img-fluid mx-auto d-block tab-img rounded"
                                      />
                                    </a>
                                  )
                                )}
                              </div>




                            </div>
                            <div className="col-md-8 col-9">
                              <div
                                className="tab-content"
                                id="v-pills-tabContent"
                              >
                                <div
                                  className="tab-pane fade show active"
                                  role="tabpanel"
                                >
                                  <div
                                    style={{
                                      borderRadius: 10,
                                      overflow: "hidden",
                                      border: "1px solid #ccc",
                                      height: 250,
                                    }}
                                  >
                                    <img
                                      src={productDetails.image?.length > 0 ? `${Global.backend}/uploads/${productDetails.image[selectedImg]?.imageURL}` : require("../../assets/img/default_product.png")}
                                      alt=""
                                      className="img-fluid mx-auto d-block"
                                      data-zoom={require("../../assets/BackOffice/images/product/img-1.png")}
                                      style={{ height: 250 }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-7">
                        <div className="mt-4 mt-xl-3">
                          {/* fssr */}
                          <div
                            className="toggle-switch"
                            style={{ color: "red" }}
                          >
                            {isVisible ? (
                              <span
                                style={{
                                  color: "white",
                                  backgroundColor: "green",
                                  fontSize: 14,
                                  fontWeight: "bold",
                                  borderRadius: 15,
                                  padding: 2,
                                  marginBottom: 15,
                                  textAlign: "center",
                                }}
                              >
                                {t("product.visible")}
                              </span>
                            ) : (
                              <span
                                style={{
                                  color: "white",
                                  backgroundColor: "red",
                                  fontSize: 14,
                                  fontWeight: "bold",
                                  borderRadius: 15,
                                  padding: 2,
                                  marginBottom: 5,
                                  textAlign: "center",
                                }}
                              >
                                {t("product.invisible")}
                              </span>
                            )}
                            <div style={{ marginTop: 5 }}>
                              <Switch
                                onChange={() => {
                                  setisVisible(!isVisible)
                                  axios.post(PRODUCT_updateVisibilite_URL, {
                                    produitId: id
                                  }).catch(() => {
                                    showAlert("error", t("request.errorUpdateProduct"))
                                  })
                                }}
                                checked={isVisible}
                              />
                            </div>
                            {/* {productDetails.visibilite} */}
                          </div>

                          <h4 className="text-primary">
                            {productDetails.nom}
                          </h4>

                          <div className="d-inline-flex">

                            <div className="text-muted me-3">
                              <Rating
                                name="half-rating-read"
                                defaultValue={moyenRating}
                                precision={0.1}
                                readOnly
                              />
                            </div>
                            <div className="text-muted">
                              ( {moyenCusmers} {t("customerreviews")})
                            </div>
                          </div>



                          <h5 className="mt-2" style={nobold}>
                            <div style={{
                              display: "flex",
                              alignItems: "center",
                              fontSize: 17
                            }}
                            >
                              {productDetails.discount ? (
                                <span
                                  className="rounded-pill bg-success mr-1"
                                  style={{ color: "white", fontSize: "1rem" }}
                                >
                                  {GlobalData.currency[currency]}{getCurrencyPrice(productDetails.prix - (productDetails.prix * productDetails.discount / 100), productDetails.currency)}
                                </span>
                              ) : (
                                <span
                                  className="badge rounded-pill bg-success mr-1"
                                  style={{ color: "white", fontSize: "1rem" }}
                                >
                                  {GlobalData.currency[currency]}{getCurrencyPrice(productDetails.prix, productDetails.currency)}
                                </span>
                              )}

                              {productDetails.discount && (
                                <span>
                                  <span
                                    style={{
                                      backgroundColor: "red",
                                      color: "white",
                                      padding: 2,
                                      borderRadius: 5,
                                      fontWeight: "bold",
                                    }}
                                    className="mr-1"
                                  >
                                    -{productDetails.discount}%
                                  </span>


                                  <a className="text-muted">
                                    <span
                                      style={{
                                        textDecoration: "line-through",
                                      }}
                                    >
                                      {GlobalData.currency[currency]}{getCurrencyPrice(productDetails.prix, productDetails.currency)}
                                    </span>
                                  </a>
                                </span>
                              )}
                            </div>
                          </h5>

                          <hr className="my-4" />

                          <div className="mt-4">
                            <h6>{t("product.description")} :</h6>

                            <div className="mt-4">
                              <p className="text-muted mb-2">
                                <i className="mdi mdi-check-bold text-success me-2"></i>
                                {productDetails.description}
                              </p>
                            </div>
                          </div>

                          <div className="mt-4">
                            <button
                              type="button"
                              className="btn waves-effect waves-light m-2"
                              onClick={() => {
                                if (isAdmin) {
                                  navigate("/dashboard/admin/editproduct/" + id);
                                } else {
                                  navigate("/dashboard/user/editproduct/" + id);
                                }
                              }}
                              style={{
                                backgroundColor: "orange",
                                color: "white",
                              }}
                            >
                              <i className="mdi mdi-delete me-2"></i>{" "}
                              {t("editProduct")}
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger waves-effect waves-light m-2"
                              onClick={() => deleteProduct()}
                            >
                              <i className="mdi mdi-delete me-2"></i>{" "}
                              {t("deleteProduct")}
                            </button>
                          </div>


                        </div>
                      </div>
                    </div>




                    <div className="container-fluid">
                      <div className="row mt-3">
                        <div className="col-lg-12">
                          <div className="card">
                            <div className="card-body">
                              <div className="table-responsive">
                                <table
                                  className="table table-centered dt-responsive nowrap"
                                  style={{
                                    borderCollapse: "collapse",
                                    borderSpacing: "0",
                                    width: "100%",
                                  }}
                                >
                                  <thead className="thead-light">
                                    <tr>
                                      <th>{t("clientDetails")}</th>
                                      <th>{t("deliveryCountries")}</th>
                                      <th>{t("product.categorie")}</th>
                                      <th>{t("product.typologie")}</th>
                                      <th>{t("product.datedepeche")}</th>
                                      <th>{t("product.productionCountry")}</th>
                                      <th>{t("product.capture")}</th>
                                      <th>{t("product.transformation")}</th>
                                      <th>{t("product.conservation")}</th>
                                      <th>{t("product.congelation")}</th>
                                      <th>{t("product.certification")}</th>
                                      <th>{t("product.emballage")}</th>
                                      <th>{t("product.glazing")}</th>
                                      <th>{t("product.taille")}</th>
                                      <th>{t("product.poidemballage")}</th>
                                      <th>{t("product.stock")}</th>
                                      <th>{t("product.prix")}</th>
                                      <th>{t("product.discount")}</th>
                                      <th>{t("product.minQte")}</th>
                                      <th>{t("product.maxQte")}</th>
                                      <th>{t("ads.views")}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>{productDetails.deliveryCountries}</td>
                                      <td><Typography color={"primary"} sx={{ fontWeight: "bold" }}>{isBusinessAccountType(productDetails.user.compte) ? productDetails.user.entreprise?.nom : ""}</Typography> ({productDetails.user.prenom} {productDetails.user.nom}) <Typography color={"secondary"} sx={{ fontWeight: "bold" }}>{productDetails.user.id == localStorage.getItem("id") ? "(" + t("me") + ")" : ""}</Typography></td>
                                      <td>{productDetails.categorie ? productDetails.categorie.nom : "-"}</td>
                                      <td>{t("product.typologies." + productDetails.typologie)}</td>
                                      <td>{productDetails.datedepeche}</td>
                                      <td>{productDetails.productionCountry}</td>
                                      <td>{t("product.captures." + productDetails.methodedecapture)}</td>
                                      <td>{t("product.transformations." + productDetails.transformation)}</td>
                                      <td>{t("product.conservations." + productDetails.conservation)}</td>
                                      <td>{t("product.congelations." + productDetails.congelation)}</td>
                                      <td>{t("product.certifications." + productDetails.certification)}</td>
                                      <td>{t("product.emballages." + productDetails.emballage)}</td>
                                      <td>{productDetails.glazing} °C</td>
                                      <td>{productDetails.taille} Cm</td>
                                      <td>{productDetails.poidemballage} G</td>
                                      <td>{productDetails.stock}</td>
                                      <td>{GlobalData.currency[currency]}{getCurrencyPrice(productDetails.prix, productDetails.currency)}</td>
                                      <td>%{productDetails.discount}</td>
                                      <td>{productDetails.min}</td>
                                      <td>{productDetails.max}</td>
                                      <td>{productDetails.vu}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>




                  </div>
                </div>

                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">{t("customerreviews")}:</h4>



                    <div className="border pr-4 pl-4 pt-2 pb-2 rounded">
                      {!commentList.length && <NotFound />}
                      {commentList.map((comm, index) => (
                        <div
                          className="media border-bottom pb-3 pt-3"
                          key={index}
                        >
                          <div className="media-body">
                            <p className="text-muted mb-2">
                              {comm.commentaire}
                            </p>
                            <h4 className="font-size-15">
                              {getUserFullName(t, comm.user)}
                            </h4>
                            <Rating
                              name="half-rating-read"
                              defaultValue={comm.etoile_nb}
                              precision={0.1}
                              size="small"
                              readOnly
                            />
                          </div>
                          <p className="float-sm-right font-size-12 text-center">
                            {comm.created_at
                              .split("T")[0]
                              .split("-")
                              .reverse()
                              .join("/")}
                            <br />
                            {comm.created_at.split("T")[1].split(":")[0] +
                              ":" +
                              comm.created_at
                                .split("T")[1]
                                .split(":")[1]
                                .split(".")[0]}
                          </p>
                        </div>
                      ))}
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        )

      }
    </LoaderComponent>
  );
};

export default MyProductDetails;
